import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LcAClDirective } from './lc-acl.directive';
import { LcACLIfDirective } from './lc-acl-if.directive';
import { LcAClService } from './lc-acl.service';

const COMPONENTS = [LcAClDirective, LcACLIfDirective];

@NgModule({
  imports: [CommonModule],
  declarations: COMPONENTS,
  exports: COMPONENTS,
})
export class LcAclModule {
  // constructor(@Optional() @SkipSelf() parentModule?: LcAclModule) {
  //   if (parentModule) {
  //     throw new Error('LcAclModule is already loaded. Import it in the AppModule only');
  //   }
  // }
  static forRoot(): ModuleWithProviders<LcAclModule> {
    return {
      ngModule: LcAclModule,
      providers: [LcAClService],
    };
  }
}
